export const Images = {
  DELETE: require("./Resources/Delete.png"),
  CREATE_VERIFICATION_ICON: require("./Resources/CreateVerification.png"),
  SUCCESS: require("./Resources/Success.png"),
  NO_APIS: require("./Resources/NoApis.png"),
  NO_WEBHOOK: require("./Resources/NoWebhooks.png"),
  NO_DAPP_ICON: require("./Resources/NoDapp.png"),
  KPMGLOGO: require("./Resources/kpmgLogo.png"),
  KPMGDARKLOGO: require("./Resources/kpmgDarkLogo.png"),
  CERTIFYLOGO: require("./Resources/certifyLogo.png"),
  APPSTORELOGO: require("./Resources/appStoreLogo.png"),
  GOOGLESTORELOGO: require("./Resources/googleStoreLogo.png"),
  SIGNWITHMICROSOFT: require("./Resources/signWithMicrosoft.png"),
  NOTIFICATIONICON: require("./Resources/notificationIcon.png"),
  COPYICON: require("./Resources/copyIcon.png"),
  AVATAR: require("./Resources/avatar.png"),
  SELECTPICTURE: require("./Resources/selectPicture.png"),
  MAILIMAGE: require("./Resources/mailImage.png"),
  CRED: require("./Resources/CREDICON.png"),
  EXPIRE: require("./Resources/TotalExpired.png"),
  REVOKE: require("./Resources/TotalRevoked.png"),
  TEMP: require("./Resources/TotalTemplates.png"),
  STOPWATCH: require("./Resources/Stopwatch.png"),
  DOWNLOAD: require("./Resources/Downloded.png"),
  RINGICON: require("./Resources/DashboardIcon.png"),
  BGPIECHART: require("./Resources/BginsidePieChart.png"),
  COLUMNSICON: require("./Resources/columns.png"),
  ARROWICON: require("./Resources/Arrowicon.png"),
  SUMMERYICON: require("./Resources/SummeryIcon.png"),
  VERIFICATIONREQUEST: require("./Resources/VerificationRequest.png"),
  VERIFICATIONPROCESS: require("./Resources/VerificationProcess.png"),
  QR: require("./Resources/qr.png"),
  APPROVED_VERFIFCATION: require("./Resources//ApprovedVerification.png"),
  PENDING_VERIFIFCATION: require("./Resources//PendingVerification.png"),
  ACCEPTED_VERIFICATION: require("./Resources/AcceptedVerification.png"),
  REJECTED_VERIFICATION: require("./Resources/RejectedVerification.png"),
  RESET_LOCK: require("./Resources/Group 1171275168.png"),
  API_KEY: require("./Resources/ApiKey.png"),
  REVOKE2: require("./Resources/Revoke.png"),
  ISSUECRED: require("./Resources/IssueCred.png"),
  BANNER: require("./Resources/banner.png"),
  DROPDOWN_ICON: require("./Resources/DropDownIcon.png"),
  SITE_LOGO: require("./Resources/siteLogo.png"),
  PANCARD: require("./Resources/pancard.png"),
  ISSUER_DASHBOARD: require("./Resources/loginCred.png"),
  ISSUER_DASHBOARD_1: require("./Resources/IssuerDashboard1.png"),
  ISSUER_DASHBOARD_2: require("./Resources/IssuerDashboard2.png"),
  WEBHOOK_STATUS: require("./Resources/webhookstatus.png"),
  CHECK_ANIMATE: require("./Resources/icons8-checkmark-ezgif.com-loop-count.gif"),
  CANCEL_ICON: require("./Resources/cancel-48.png"),
  CERTIFY_WHITE_LOGO: require("./Resources/logo.png"),
  QR_CODE: require("./Resources/qr-code.png"),
  KPMG: require("./Resources/Kpmg.jpeg"),
  LANDING: {
    BG: require("./Resources/landing/BackgroundHero.png"),
    BG_MIDDLE: require("./Resources/landing/Background Integrations.png"),
    BG_FOOTER: require("./Resources/landing/Background Footer.png"),
    CERTIFICATE_SHOWCASE: require("./Resources/landing/image 96.png"),
    LEARNING_SECTION1: require("./Resources/landing/image 97.png"),
    LEARNING_SECTION2: require("./Resources/landing/image 98.png"),
    LEARNING_SECTION3: require("./Resources/landing/image 99.png"),
    LOGO: require("./Resources/landing/logo.png"),
  },
  LANDSCAPTOPORT: require("./Resources/landscape-to-portrait-icon-85193-512.png"),
  PORTRAITTOLAND: require("./Resources/portrait-to-landscape-icon-85192-512.png"),
  UPLOADFILEIMG: require("./Resources/Ellipse.png"),
  PDFIMAGE: require("./Resources/pdfImg.png"),
  EXCEL: require("./Resources/Excel.png"),
};
